var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _rect3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect4, _path24, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLightChair = function SvgLightChair(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 241,
    viewBox: "0 0 234 241",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.23 130.08V179.98L185.87 185.26V163.87L152.97 176.81V199.35L136.43 206.43V156.04L198.23 130.08Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.5303,
    y: 95.3701,
    width: 133,
    height: 145,
    fill: "url(#pattern0)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.43 156.05L72.23 129.08V179.41L136.43 206.43V156.05Z",
    fill: "#5BBEAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.23 129.08L136.42 156.05L198.22 130.09L132.46 104.14L72.23 129.08Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3599 40.2599L84.1999 16.1499L132.47 36.0999L72.2299 60.5699L25.3599 40.2599Z",
    fill: "#CAEDFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2299 60.5598V179.41L56.8699 173.05V146.69L36.6399 138V164.67L25.3599 160V40.2598L72.2299 60.5598Z",
    fill: "#FFB45D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5701 172.92L36.6401 164.73V164.67L56.5701 172.92Z",
    fill: "#FCEEE1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6602 164.67L56.9102 155.31V146.69L36.6602 138V164.67Z",
    fill: "#0D3260"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.88 185.27L162.56 173.06L185.88 163.88V185.27Z",
    fill: "#5BBEAA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M198.23 130.08V179.98L185.87 185.26V163.87L152.97 176.81V199.35L136.43 206.43V156.04L198.23 130.08Z",
    fill: "url(#paint2_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.23 129.36V60.5701L132.47 36.1001V104.14L72.23 129.36Z",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5303,
    y: 0.370117,
    width: 132,
    height: 165,
    fill: "url(#pattern1)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5303,
    y: 67.3701,
    width: 197,
    height: 124,
    fill: "url(#pattern2)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M72.1299 129.36V60.5701L132.37 36.1001V104.14L72.1299 129.36Z",
    fill: "url(#paint4_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.23 129.08L136.42 156.05L198.22 130.09L132.46 104.14L72.23 129.08Z",
    fill: "url(#paint5_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122 85.1399C122 96.3499 131.09 109.21 142.3 113.85C148.92 116.6 154.8 115.85 158.5 112.5C161.08 110.16 162.6 106.5 162.6 101.96C162.6 90.7499 153.51 77.89 142.3 73.25C131.09 68.61 122 73.9299 122 85.1399Z",
    fill: "#FFB45D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.49 128.38C152.196 125.724 153.112 123.13 154.23 120.62C154.23 120.62 154.97 118.95 158.46 112.5L125.91 98.8198C127.61 102.61 129.34 106.82 130.96 111.33C132.22 114.83 133.27 118.13 134.16 121.18L151.49 128.38Z",
    fill: "#FFB45D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.23 126.59L150.16 132.77C150.89 133.08 151.49 132.77 151.49 131.99V130.41C151.457 130.006 151.316 129.618 151.082 129.288C150.848 128.957 150.53 128.695 150.16 128.53L135.23 122.35C134.5 122.05 133.9 122.35 133.9 123.13V124.71C133.933 125.114 134.073 125.501 134.307 125.832C134.541 126.163 134.86 126.424 135.23 126.59Z",
    fill: "#024B85"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.48 130.92L149.91 136.92C150.78 137.28 151.49 136.86 151.49 135.99C151.452 135.51 151.285 135.05 151.007 134.657C150.729 134.265 150.35 133.955 149.91 133.76L135.48 127.76C134.61 127.4 133.9 127.82 133.9 128.69C133.938 129.169 134.105 129.63 134.383 130.022C134.661 130.415 135.04 130.725 135.48 130.92V130.92Z",
    fill: "#024B85"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.78 135.84L147.61 139.91C148.34 140.21 148.94 139.91 148.94 139.13V138.63C148.908 138.226 148.768 137.838 148.534 137.507C148.3 137.176 147.981 136.914 147.61 136.75L137.78 132.68C137.05 132.38 136.45 132.68 136.45 133.46V133.96C136.482 134.364 136.622 134.752 136.856 135.083C137.091 135.414 137.41 135.675 137.78 135.84V135.84Z",
    fill: "#024B85"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.05 103.45L146.74 104.14C147.043 104.323 147.383 104.438 147.735 104.478C148.087 104.517 148.443 104.481 148.78 104.371C149.117 104.261 149.426 104.08 149.686 103.84C149.947 103.6 150.153 103.307 150.29 102.98C150.701 102.179 150.843 101.266 150.693 100.377C150.544 99.4889 150.111 98.6727 149.46 98.0501C149.165 97.7914 148.812 97.6066 148.432 97.5112C148.051 97.4157 147.653 97.4124 147.271 97.5013C146.889 97.5903 146.534 97.769 146.234 98.0226C145.935 98.2763 145.7 98.5977 145.55 98.9601C145.401 99.2421 145.287 99.5409 145.21 99.8501V99.8501L145.14 101.51L145.05 103.45Z",
    stroke: "#024B85",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.05 103.45L144.04 125.33",
    stroke: "#024B85",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M145.05 103.45L142.33 102.32",
    stroke: "#024B85",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M140.34 101.49L138.66 100.79C137.4 100.52 135.88 98.7898 135.1 96.6798C134.25 94.3698 134.62 92.4698 135.93 92.4398C137.24 92.4098 138.99 94.2698 139.84 96.5898C139.981 96.9711 140.095 97.3621 140.18 97.7598V97.7598L140.25 99.4798L140.34 101.49Z",
    stroke: "#024B85",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M141.35 124.21L140.34 101.49",
    stroke: "#024B85",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M143.06 102.62L140.34 101.49",
    stroke: "#024B85",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.530273,
    y: 103.37,
    width: 92,
    height: 96,
    fill: "url(#pattern3)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.6602 164.54L56.9102 155.18V146.56L36.6602 137.87V164.54Z",
    fill: "#0D3260"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0075188 0.00689655)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1",
    transform: "scale(0.00757576 0.00606061)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2",
    transform: "scale(0.00507614 0.00806452)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3",
    transform: "scale(0.0108696 0.0104167)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 136.43,
    y1: 168.25,
    x2: 198.23,
    y2: 168.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43AEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3B9BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#256998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3260"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 72.23,
    y1: 130.09,
    x2: 198.22,
    y2: 130.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DDEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 136.43,
    y1: 168.25,
    x2: 198.23,
    y2: 168.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43AEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#41A9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3B9BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3083B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#226190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0F3765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3260"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 72.23,
    y1: 82.7301,
    x2: 132.47,
    y2: 82.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43AEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#28709F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3260"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 40862.4,
    y1: 7564.98,
    x2: 44491.3,
    y2: 7564.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43AEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#28709F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3260"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 72.23,
    y1: 130.09,
    x2: 198.22,
    y2: 130.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C8EDFD",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C1ECFC",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#B5EBFB",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A5E9F9",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#91E7F7",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#78E4F4",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#5AE1F0",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DDEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 133,
    height: 145,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1",
    width: 132,
    height: 165,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2",
    width: 197,
    height: 124,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMUAAAB8CAYAAADZ/XRNAAAACXBIWXMAAAsSAAALEgHS3X78AAAHk0lEQVR4Xu3dyYskRRjG4Td03LeLoh7Eg4IgKAiCoCBeFPSi4P8jIrgruAsuyBwUUXEBd0EGUWEEURhBFEYQURTGBQT37vRQlVPRX0XEF7lUdy2/B4qqyfgis5Z4I7Kqp7tC0zQCMHOMVwBsGkIBGIQCMAgFYBAKwCAUgEEoAINQAAahAAxCARiEAjAIBWAQCsAgFIBBKACDUAAGoQAMQgEYhAIwCAVgEArAIBSAQSgAg1AABqEADEIBGIQCMAgFYBAKwCAUgEEoAINQAAahAAxCARiEAjAIxd660yvA7gt8EeSeuFfSdghhu2mabUnbkrYk3VrshV1BKHbPg5oM/txly/z7jvRusGiEYvEe1fyqsG23hRC2bPv0ck9ux1gMQrEYT6q8KswFIw5FKkDTywPzh8LYCMW4nlFFEOJLFAB7+lS6PCIsDKEY7jlNBupWYYZPhcBesqFwTr2eEEZFKPp7QZWDuvIypP+WJqsURkAountZFYO6x6rRKxTTfdi+zwq9EYoKIYTXvQGunoO6veQ+ffI+tao49otCJ/u8gg33tqR2AGaFEJSaXOz2VF27LTc5pba322r2L+lmTcLxim1AGqGY9752zrQ7pAZeTSBydUNWahsOZ183avaY3igVbjpCMfOBMkGI5QaeDUHFDN5b6ViVrtfkcb7jFW6iTQ/FQUXn5UMGb+60KNWWUjq1srebphklaCGEa5vZz0gOOOUbY1ND8amiVaHm9KOtqR2MufP+HO/UKrXydL1PKVHfqzV5Pj4s91h/mxSKQ8q8V6gJQ5dZP9a1vlUa6Pa+9D1Gpt+Vmj1Hn6QK1t0mhOJLVbxXyA3CmgE3ZKbOsSuD3dZuH/u4Zp+Xa/bcfZ7ttGbWNRSHlVgVcufoUv0nSCk1NUP1DazlPabC83CpJs/lF3MFa2bdQvGtEqtC6j2DnYn7DjpvkA1h73fNsbwar3+K6XOxZs/x18kOK25dQvGDZj/VneMNBK89xxuAXess26dmHzU1ng6naxdq8px/ozWyyqE4osIP2Wp4g9Vrrx2ANXXesXL69ivJ7a9wnPM1ex2+zxWtilX8wwW/hRB+8Yqk2YyXk5oJS+1deMe2vGPl9uf1s7rery6m+z5X0tlO6VJblZXiD0WrQtPMfzafmjErlv+j2+P6VN0iZuQuao5d+iCh5e2n7+NM9DtLs9fs12SnJbXsK8U/kv5KNXgBSCmdFsRtuboQwo6ZdpGzrjX2sfquPD37nSHptFLBMlnGUDSazC7/eYWeIQMpdSpVG564LXcfut43uyp6NZ4utbHaCSPjFEknSTrBK9xLyxiKmie3SukF9La1p2glXrtU3k9Nf88YARkiPvX0jmnu63GSjpU0/EkY2TKGIjRNc4yUPl2pGdCe0rl2vC/vRfbaS2oGkRUPwFbNCmLV1tXoMvF0fbx7ZRlD0drXNM3xTdOc2G7IDaTUNvui1A6ERbxwffeZWr1y7ORRqqu9P12fwy4TiqR/NfnZklu425Y5FLGTJZ2aaqg9fYhXAu/F7aLd1yJOkSoG1lHxhJFa9eK6XFsrtSJ5YfLaI39K+tsr2kur8pFs6/To9hEpv0rkXlBbX3ox27ZSTW6/tt2qOe4YUgPc0+U5asVhy9T+ntq4jFYtFLEzp9c/2obcKpFSmg29AZ9SM4Ck/HFr+9eqnRxKBtT+nKtbZqscitY50+vvilUZfQdKTp99pIIo5QPSNThtfZ8VoKefvIJltg6haJ0X3T4cN8SnQVK3gesNHK99iNzqUTu4bdi9/bRS+6t4nL0mpWW0TqGIXTC9/krS0UCUBk6sy+rRZWCNpXZwW7nHattqn6eptfofstL6hqJ1UXujaZpDpcLYGCtDTU3ujbw36Gv23fLub5d9GWv5uxTS+ocidsn0+rNcgTeApEGDaE4uEF14b9JLbT2s/W/dSZsVitZl0e2DccOQQdN30A1ZBST/tKemzUo8lo35/WxpM0MRu2J6/VGxypGb7bsMxGUyvd8b+Zc8JELRump6faDd4J3nl7YPCYO34njtI/jYK1h3hGKna9obTdO8GzfYgdgOzprg5OQClXsD3rbn+taIV7FoHwdKfTYNoci7bnr9ZqoxFYauAcm15wJhayyvjzT3HuS9QunGIhS+G6Lbr6YKUgPRG5yePv079HnLK9hkhKKbm6bXLxWrHKkZ3X60KtWtGK2KutdKjZjhm4yGeV6zX84f9E1GXv+Q+bqwkPh6L1PLNxl1RCjGs1/+wO8dio59+c67AQjF+J5WZvCmZvtoW69QmJVivzAYoVigEMLjqVMemUEtKfUNp+4lCtRTwmgIxe54WDsHcddvOE1dHps7CkZBKHbf/UoP8tpQPDS/S4yJUOyduxWtGCGELUlz7zmml/sK+8HICMUeCyHcXnijfVepLxaDUCyREMItTdPc5tVhsQgFYKzKH0MDdg2hAAxCARiEAjAIBWAQCsAgFIBBKACDUAAGoQAMQgEYhAIwCAVgEArAIBSAQSgAg1AABqEADEIBGIQCMAgFYBAKwCAUgEEoAINQAAahAAxCARiEAjAIBWAQCsAgFIBBKACDUAAGoQAMQgEY/wNe3mSZIB5mCQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3",
    width: 92,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABgCAYAAACQVxWOAAAACXBIWXMAAAsSAAALEgHS3X78AAACDklEQVR4Xu3bwWrDMBAA0d3S//9l9RKliirbGMpkFWagOHF0elZkpeBsrYVxfV0NsP9NcDjB4QSHExxOcDjB4QSHExxOcDjB4QSHExxOcDjB4QSHExxOcDjB4QSHExxOcDjB4QSHExxOcDjB4QSHExxOcDjB4QSHExxOcDjB4b6vBtBl5vOho9Zano3dsXIzfHzI64Hfxouwe+XAV7XWIjM/Ar4ceGY+Z3k/Zr6sLG1n/HLgj9n8fN8vwOp50h3hy4GvsMfz47mhbWZ9VnsS+Qpt/gYcjYmIkjuccjN8ngDz+449LjP99bzDubp476gc+Aja3x99C8dlZjxGxJ8LUKVy4L15Le91yHmmry7M1dLzjsqCj3hn28TMfGKPx7Nvxjvb7qZ5p4o3zy1m+Orc0c11PlarLPjdNXn1mWv4zVbo8zq+2A6+3FSrVe7fs6tWoP31DFsZO6LoDJ+Bx79+bhx7sp6Xky83w+/M0IOx2T+rWDnwFfYIO+6zx8+j2PbvqHLgEb+o8w1yfv0YuwV0ryT4aq2OeLkQWyGPlfulGRFtNbt3WjbOKjfDD3Yi20P3yoFHfM5sXlVxSfnoSv7w+eQEhxMcTnA4weEEhxMcTnA4weEEhxMcTnA4weEEhxMcTnA4weEEhxMcTnA4weEEhxMcTnA4weEEhxMcTnA4weEEhxMcTnA4weEEhxMc7gca5PTBT4QikQAAAABJRU5ErkJggg=="
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightChair, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightChair.40a7234f.svg";
export { ForwardRef as ReactComponent };